export default __webpack_public_path__ + "static/media/10.450aa06f.png";